const PercentageSlider = ({ percentage, backgroundColour, count }: PercentageSliderProps) => {
  return (
    <div className="h-4 w-full flex relative">
      <div
        className="absolute w-full h-full bg-gray-100 rounded-md"
      />
      <div
        className="text-black absolute z-[9] text-right pr-2 font-medium text-xs leading-3 rounded-md"
        style={{
          width: `${percentage}%`,
          minWidth: "5px",
          maxWidth: "100%",
          backgroundColor: backgroundColour,
          lineHeight: "16px",
        }}
      >
        {count}
      </div>
    </div>
  );
};

interface PercentageSliderProps {
  percentage: number;
  backgroundColour: string;
  count: number;
}

export default PercentageSlider;
